module.exports = __webpack_public_path__ + "img/share-popup-rule.1ed7d4c4.png";